<ep-sub-panel [form]="form" panelType="box" [title]="getControlValue('Document.Doc_Name')">
  <form [formGroup]="form">
    <ep-row>
      <section class="col-12 col-md-6">
        <ep-field-section>
          <ep-field columnSpan="4" label="Name" format="text-120" controlPath="Document.Doc_Name"></ep-field>
          <ep-field
            columnSpan="2"
            label="Class"
            format="dropdownSelector-DocClass"
            controlPath="Document.Doc_Class"
          ></ep-field>
        </ep-field-section>
      </section>
      <section class="col-12 col-md-6">
        <ep-field-section>
          <ep-field
            columnSpan="6"
            label="Description"
            format="textbox-4099"
            [options]="{ rows: 3 }"
            controlPath="Document.Doc_Desc"
          ></ep-field>
        </ep-field-section>
      </section>
    </ep-row>
  </form>
</ep-sub-panel>
